import React, { useEffect, useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateModel from "./AiModels/CreateModel";
const AiModels = () => {
  const [openCreateModel, setOpenCreateModel] = useState(false);

  useEffect(() => {
    console.log(openCreateModel);
  }, [openCreateModel]);

  return (
    <div className="px-4 py-6">
      <CreateModel
        isOpen={openCreateModel}
        setIsOpen={setOpenCreateModel} // Pass state and handler as props
      />
      <div className="p-[14px] shadow-cs rounded-lg mb-[20px] bg-white">
        <h1 className="text-[18px] md:text-[20px] cursor-pointer font-semibold text-gray-900 mb-2">
          Ai Models
        </h1>
        <div className="flex items-center text-sm text-gray-500">
          <a href="/" className="hover:text-gray-700">
            Home
          </a>
          <span className="mx-2">
            <ChevronRightIcon />
          </span>
          <span className="text-gray-700">Ai Models</span>
        </div>
      </div>
      <div className=" flex items-center justify-between flex-wrap gap-[14px] md:gap-[0] mb-[20px]">
        <div className="flex items-center gap-[16px]">
          <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium   rounded-2xl shadow-cs bg-white text-[13px] md:text-[14px] text-[#8125b0]">
            geminiAi: 99157
          </button>
          <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium  rounded-2xl shadow-cs bg-white text-[13px] md:text-[14px] text-[#008000]">
            OpenAi: 76904
          </button>
        </div>
        <button
          onClick={() => setOpenCreateModel(true)}
          className=" justify-center create-model md:flex items-center rounded-lg text-[14px] pb-[8px] pt-[8px] pl-[14px] gap-[2px] pr-[14px] bg-[#27004a] text-[white]"
        >
          <AddIcon className="icons-crm" />
          Create Model
        </button>
      </div>
      <div className="p-[14px] shadow-cs bg-white flex items-center justify-between rounded-lg">
        <div>
          <h3 className="text-[13px] md:text-[15px] text-[#262323]">
            Flowchanger AI It Services support
          </h3>
          <span className="text-[13px] md:text-[14px] text-[#2b2a2d]">
            3 months ago
          </span>
        </div>
        <DeleteIcon className="text-[red] cursor-pointer" />
      </div>
    </div>
  );
};

export default AiModels;
